import {Grid, Stack} from "@mui/material";
import React from "react";
import {ConversationsTable} from "./components/ConversationsTable";
import {ConversationPreviewModal} from "./components/ConversationPreviewModal";
import {ConversationComment} from "./components/ConversationComment";
import {ConversationStatusGauge} from "./components/ConversationStatusGauge";
import {DashboardContextProvider, useDashboard} from "../../../context/DashboardContext";
import {SpeechToTextCard} from "./components/SpeechToTextCard";
import {TextToSpeechCard} from "./components/TextToSpeechCard";
import {ChatbotCard} from "./components/ChatbotCard";
import {ActiveCallsCard} from "./components/ActiveCallsCard";
import {TagsUsageChart} from "./components/tags-usage-chart";


export const ProjectDashboard = ({project}) => {
  return (
    <DashboardContextProvider project={project}>
      <ProjectDashboardContent project={project} />
    </DashboardContextProvider>
  );
};

const ProjectDashboardContent = ({project}) => {
  const {statuses} = useDashboard();

  const type = project?.settings?.projectType || "VOICE_BOT"
    console.log(project.id)

  return (
    <>
      <ConversationPreviewModal project={project}/>
      <ConversationComment project={project}/>
      <Grid container spacing={2}
            sx={{p: {xs: 2, md: 4}, maxHeight: "calc(100dvh - 40px)", overflowY: "auto", overflowX: "hidden"}}>
        {
          type === "VOICE_BOT" && <>
            <Grid item xs={12} sm={6} lg={3}>
              <SpeechToTextCard />
            </Grid>
            <Grid item xs={12} sm={6} lg={3}>
              <TextToSpeechCard />
            </Grid>
            <Grid item xs={12} sm={6} lg={3}>
              <ChatbotCard />
            </Grid>
            <Grid item xs={12} sm={6} lg={3}>
              <ActiveCallsCard />
            </Grid>
          </>
        }

        <Grid item xs={12} sm={6} md={12} lg={7} xl={8}>
          <ConversationsTable project={project} />
        </Grid>

        <Grid item xs={12} sm={6} md={6} lg={5} xl={4}>
          <Stack direction={"column"} gap={2} sx={{height: "100%"}}>
            {/*<ConversationStatusPolar resolved={statuses?.RESOLVED || 0} unresolved={statuses?.UNRESOLVED || 0} missedCalls={statuses?.MISSED_CALL || 0} />*/}
            <ConversationStatusGauge project={project} resolved={statuses?.RESOLVED || 0} unresolved={statuses?.UNRESOLVED || 0} missedCalls={statuses?.MISSED_CALL || 0} />
            <TagsUsageChart project={project}/>
          </Stack>
        </Grid>

      </Grid>
    </>
  )
}